import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Administration Office' },
    { value: 2, label: 'Art Room' },
    { value: 3, label: 'AV Room' },
    { value: 4, label: 'Classroom' },
    { value: 5, label: 'Connected Classroom' },
    { value: 6, label: 'Classroom' },
    { value: 7, label: 'Computer Learning Space' },
    { value: 8, label: 'Common Room' },
    { value: 9, label: 'Dark Room' },
    { value: 10, label: 'Drama Room' },
    { value: 11, label: 'Fitness Lab' },
    { value: 12, label: 'Food Tech Lab' },
    { value: 13, label: 'Graphics Room' },
    { value: 14, label: 'Gymnasium' },
    { value: 15, label: 'Hall' },
    { value: 16, label: 'Language Room' },
    { value: 17, label: 'Library' },
    { value: 18, label: 'Meeting' },
    { value: 19, label: 'Metal Tech Lab' },
    { value: 20, label: 'Multi Media Workshop' },
    { value: 21, label: 'Music Room' },
    { value: 22, label: 'Outdoor Learning Area' },
    { value: 23, label: 'Performance Workshop' },
    { value: 24, label: 'Hydrotherapy - Pool' },
    { value: 25, label: 'Practical' },
    { value: 26, label: 'Reading Area' },
    { value: 27, label: 'Science Lab' },
    { value: 28, label: 'Seminar Room' },
    { value: 29, label: 'Special Programs' },
    { value: 30, label: 'Staff Room' },
    { value: 31, label: 'Senior Study' },
    { value: 32, label: 'Study Room' },
    { value: 33, label: 'Technology Room' },
    { value: 34, label: 'Textiles Lab' },
    { value: 35, label: 'Tiered Learning Space' },
    { value: 36, label: 'Therapy Rooms' },
    { value: 37, label: 'Wood Tech Workshop' },
    { value: 38, label: 'Work Room' },
    { value: 39, label: 'Wood/Metal Tech Labs' },
    { value: 40, label: 'Other' },
  ],
});
